// Design-system tokens from itinerary-generator.pen (v3 workflow + Phase 6).
// The custom properties are promoted to `:root` so recommendation/ and
// generator/ components resolve `var(--rec-*)` even when not rendered
// inside a `.tokens` wrapper. The `.tokens` class remains for the
// font-family / color base styling it applies to its subtree.
:root {
  --rec-color-background: #ffffff;
  --rec-color-surface: #fafafa;
  --rec-color-foreground: #121926;
  --rec-color-muted: #64748b;
  --rec-color-muted-fg: #475569;
  --rec-color-border: #e2e8f0;
  --rec-color-border-strong: #cbd5e1;

  --rec-color-header-bg: #f8fafc;
  --rec-color-header-border: #e2e8f0;

  --rec-color-brand: #8b5cf6;
  --rec-color-brand-fg: #ffffff;
  --rec-color-brand-muted: #6d28d9;
  --rec-color-brand-surface: #f5f3ff;
  --rec-color-brand-border: #e9d5ff;

  --rec-color-accent: #eef2ff;
  --rec-color-accent-border: #c7d2fe;
  --rec-color-accent-fg: #4f46e5;

  --rec-color-primary: #8b5cf6;
  --rec-color-primary-fg: #ffffff;
  --rec-color-primary-hover: #6d28d9;

  --rec-color-btn-dark: #0f172a;
  --rec-color-btn-dark-fg: #ffffff;
  --rec-color-btn-dark-hover: #1e293b;

  --rec-color-success: #d1fae5;
  --rec-color-success-alt: #16a34a;
  --rec-color-success-fg: #065f46;
  --rec-color-success-dot: #10b981;
  --rec-color-success-surface: #dcfce7;

  --rec-color-warning: #fef3c7;
  --rec-color-warning-fg: #92400e;
  --rec-color-warning-dot: #f59e0b;
  --rec-color-warning-border: #fcd34d;

  --rec-color-error: #ef4444;
  --rec-color-error-bg: #fee2e2;
  --rec-color-error-fg: #991b1b;
  --rec-color-error-dot: #ef4444;

  --rec-color-info-bg: #dbeafe;
  --rec-color-info-fg: #1e40af;
  --rec-color-info-dot: #3b82f6;

  // Sky palette for the TRANSPORT category pill (Pencil node `Oxsep`
  // override). Distinct from `info-*` so transport reads cooler than
  // generic info badges.
  --rec-color-sky-bg: #e0f2fe;
  --rec-color-sky-fg: #0369a1;

  --rec-color-purple-bg: #ede9fe;
  --rec-color-purple-fg: #5b21b6;
  --rec-color-purple-dot: #7c3aed;

  --rec-color-neutral-bg: #f8fafc;
  --rec-color-neutral-chip: #f1f5f9;

  --rec-color-orange-bg: #ffedd5;
  --rec-color-orange-fg: #9a3412;
  --rec-color-pink-bg: #fce7f3;
  --rec-color-pink-fg: #9d174d;
  --rec-color-green-bg: #dcfce7;
  --rec-color-amber-bg: #fef3c7;

  --rec-radius-lg: 12px;
  --rec-radius-md: 8px;
  --rec-radius-sm: 4px;
  --rec-radius-full: 100px;

  --rec-spacing-xs: 4px;
  --rec-spacing-sm: 8px;
  --rec-spacing-md: 12px;
  --rec-spacing-base: 16px;
  --rec-spacing-xl: 24px;

  --rec-font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    sans-serif;
}

// Base typographic styling for the recommendation/generator subtree.
.tokens {
  color: var(--rec-color-foreground);
  font-family: var(--rec-font);
}
